import PropTypes from 'prop-types';
import React from 'react';
import humanize from 'underscore.string/humanize';

const DEFAULT_CHANNEL_COLOR = 'rgba(0,0,0,.025)';

const Channel = (props) => {
  const {
    channel,
    color,
  } = props;
  let notsetCls = '';
  if (channel === '--NOT-SET--') {
    notsetCls = 'notset';
  }
  return (
    <div className="channel">
      <span style={{ backgroundColor: color }} className={`${notsetCls} circle`} />
      <span className={`${notsetCls} uk-text-muted`}>
        {humanize(channel)}
      </span>
    </div>
  );
};

Channel.propTypes = {
  channel: PropTypes.string,
  color: PropTypes.string,
};

Channel.defaultProps = {
  color: DEFAULT_CHANNEL_COLOR,
  channel: '--NOT-SET--',
};

export default Channel;



// WEBPACK FOOTER //
// ./src/components/Channel.js